import { Component, OnInit } from '@angular/core';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { HistorialAsignacionOrden } from '../models/historial-asignacion-ordenes.model';
import { LogisticaService } from '../services/logistica.service';

@Component({
  selector: 'app-consulta-historial-cita',
  templateUrl: './consulta-historial-cita.component.html',
  styleUrls: ['./consulta-historial-cita.component.scss']
})
export class ConsultaHistorialCitaComponent implements OnInit {
  ordenes: HistorialAsignacionOrden[] = []
  doc?: number;

  constructor(
    private logiticaService: LogisticaService,
    private helpers: HelpersService) { }

  ngOnInit(): void {
  }

  async ObtenerHistorialAsignacionOrdenes(doc: number) {
    var obj_response = await this.logiticaService.getConsultaHistorialAsignacionOrdenes(doc);
    if (obj_response.success === true) {
      this.ordenes = obj_response.data;
    }
  }

  consultar(event) {
    showSpinner()
    const filterValue = (event.target as HTMLInputElement).value;
    this.doc = parseInt(filterValue);
    
    this.ObtenerHistorialAsignacionOrdenes(this.doc);
    hideSpinner()
  }

}
